import React from "react";
import PropTypes from "prop-types";
import * as ReadingLevelSelector from "../../data/ReadingLevelSelector";
import CardContainer from "react/containers/CardContainer";
import ReadingLevelContainer from "react/containers/ReadingLevelContainer";

const ReadingLevelFeatureContainer = (props) => {
	const lexileModel = ReadingLevelSelector.getLexile();

	return (
		<CardContainer
			cardName="Reading Level: Lexile"
			cardModel={lexileModel}
			component={ReadingLevelContainer}
			{...props}
		/>
	);
};

ReadingLevelFeatureContainer.propTypes = {
	onNullRender: PropTypes.func
}

export default ReadingLevelFeatureContainer;



// WEBPACK FOOTER //
// ./src/react/containers/ReadingLevelFeatureContainer.jsx